import TKTracker, { TrackerOptions } from '@tk/components/tracker/tk.tracker';
import TKGoogleTracker from '@tk/components/tracker/tk.google.tracker';
import TKMatomoTracker from '@tk/components/tracker/tk.matomo.tracker';

// Registry of tracker
TKTracker.registerTracker(
    'google',
    async (trackingId: string, options?: TrackerOptions) => new TKGoogleTracker(trackingId, options),
);
TKTracker.registerTracker(
    'matomo',
    async (trackingId: string, options?: TrackerOptions) => new TKMatomoTracker(trackingId, options),
);
